import { Activity, Code, Eye } from 'lucide-react';
import type { FieldErrors } from 'react-hook-form';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import type { FormFieldSchema } from '../types';
import { SchemaTab } from './schema-tab';
import { StatusTab } from './status-tab';
import { ViewTab } from './view-tab';

interface PreviewDebugTabsProps {
  fields: FormFieldSchema[];
  formValues: Record<string, unknown>;
  isValid: boolean;
  isDirty: boolean;
  errors: FieldErrors<Record<string, unknown>>;
  touchedFields: Record<string, unknown>;
  onGetFile?: (fileId: number) => Promise<{ fileName: string; fileType: string; viewUrl?: string }>;
}

export function PreviewDebugTabs({
  fields,
  formValues,
  isValid,
  isDirty,
  errors,
  touchedFields,
  onGetFile,
}: PreviewDebugTabsProps) {
  return (
    <div className="flex flex-col min-h-0 bg-slate-50/30 dark:bg-slate-900/10">
      <Tabs defaultValue="view" className="flex flex-col h-full">
        <div className="px-4 py-2 bg-muted/30 border-b">
          <TabsList className="grid grid-cols-3 w-full h-8">
            <TabsTrigger value="view" className="text-[10px] gap-1.5">
              <Eye className="w-3 h-3" />
              Preview
            </TabsTrigger>
            <TabsTrigger value="schema" className="text-[10px] gap-1.5">
              <Code className="w-3 h-3" />
              Schema
            </TabsTrigger>
            <TabsTrigger value="status" className="text-[10px] gap-1.5">
              <Activity className="w-3 h-3" />
              Status
            </TabsTrigger>
          </TabsList>
        </div>

        <div className="flex-1 overflow-hidden">
          <TabsContent value="view" className="h-full m-0 p-8 overflow-y-auto custom-scrollbar">
            <ViewTab fields={fields} formValues={formValues} onGetFile={onGetFile} />
          </TabsContent>

          <TabsContent value="schema" className="h-full m-0 overflow-hidden flex flex-col">
            <SchemaTab formValues={formValues} />
          </TabsContent>

          <TabsContent value="status" className="h-full m-0 overflow-hidden">
            <StatusTab
              isValid={isValid}
              isDirty={isDirty}
              errors={errors}
              touchedFields={touchedFields}
              fields={fields}
            />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
